import Inputmask from 'inputmask'

export function initInputmask() {
  const phones = document.querySelectorAll('input[type="tel"]')
  // const emails = document.querySelectorAll('input[type="email"]')

  Inputmask({mask: '+7 (999) 999-99-99'}).mask(phones)
  // Inputmask({regex: String.raw`\d*`}).mask(emails)
}
